import { Public } from '@middlewares';

import Login from '@pages/auth/Login';
import Register from '@pages/auth/Register';
import Confirmation from '@pages/auth/Confirmation';
import RecoveryPasswd from '@pages/auth/RecoveryPasswd';
import UnsubscribedRequest from '@pages/auth/UnsubscribedRequest';
import PrivacyPolicy from '@pages/auth/PrivacyPolicy';
import ChangePassword from '@pages/auth/ChangePassword';
import HelpCenter from '@pages/auth/HelpCenter';

const AuthRoutes = [
  {
    path: '/login',
    element: <Public title="Iniciar sesión" page={<Login />} />,
  },
  {
    path: '/confirmar-celular/:id',
    element: <Public title="Confirmar celular" page={<Confirmation />} />,
  },
  {
    path: '/invitado/:id',
    element: <Public title="Registro" page={<Register />} />,
  },
  {
    path: 'recovery-passwd/:id',
    element: <Public title="Recuperar contraseña" page={<RecoveryPasswd />} />,
  },
  {
    path: 'solicitud-baja',
    element: <Public title="Solicitud de baja" page={<UnsubscribedRequest />} />,
  },
  {
    path: 'privacidad',
    element: <Public title="Politicas de privacidad" page={<PrivacyPolicy />} />,
  },
  {
    path: '/cambio-validation/:id',
    element: <Public title="Cambiar contraseña" page={<ChangePassword />} />,
  },
  {
    path: '/soporte',
    element: <Public title="Soporte" page={<HelpCenter />} />,
  },
];

export default AuthRoutes;
